/**
 * Dazway mark shown at the top of the navigation rail.
 *
 * The same shape as DazwayMark in Auth/components/AuthIcons, kept separate because each
 * copy needs its own gradient id: two renders sharing one id would make the second read
 * the first one's definition, and the auth screens are a different mount entirely.
 */
const DazwayRailLogo = () => (
    <svg width="36" height="36" viewBox="0 0 100 100" fill="none" role="img" aria-label="Dazway">
        <defs>
            <linearGradient id="dazwayRailLogo" x1="0" y1="0" x2="1" y2="1">
                <stop stopColor="#0060FC" />
                <stop offset="1" stopColor="#01194A" />
            </linearGradient>
        </defs>
        <path d="M26 12h20c21 0 38 17 38 38S67 88 46 88H26z" fill="url(#dazwayRailLogo)" />
        <path d="M34 42h26a6 6 0 0 1 6 6v22a6 6 0 0 1-6 6H50L34 88z" fill="#fff" />
        <rect x="34" y="54" width="20" height="34" rx="4" fill="url(#dazwayRailLogo)" />
    </svg>
);

export default DazwayRailLogo;
